import ProductAdsTable from "../category/advertisements/ProductAdsTable";

export const AdvertisingSection = ({ productId }) => {
  return (
    <ProductAdsTable
      productId={productId}
      showAdColumn={true}
      showProductColumn={false}
      persistKey={"productDetailsPageAdProductsTable"}
    />
  );
};
